import { config } from '@iheartjane/config';
import type { LatLong } from '@iheartjane/geolocation';

/* eslint-disable-next-line no-restricted-imports */
import type { DeliveryValidation } from '@jane/shared/types';

import { request } from '../lib/request';

export const DeliveryValidateSource = {
  async get({
    storeId,
    zipcode,
    coordinates,
  }: {
    coordinates: LatLong | undefined;
    storeId: string | number;
    zipcode: string | undefined | null;
  }): Promise<DeliveryValidation> {
    const url = `${config.apiPath}/delivery/validate`;

    const params = {
      store_id: storeId,
      user_latitude: coordinates?.lat || '',
      user_longitude: coordinates?.long || '',
      user_zipcode: zipcode || '',
    };

    const result = await request(
      url,
      {
        method: 'GET',
      },
      params
    );
    return result as DeliveryValidation;
  },
  getSource({
    storeId,
    zipcode,
    coordinates,
  }: {
    coordinates?: LatLong | undefined;
    storeId: string | number;
    zipcode?: string | undefined | null;
  }) {
    let url = `${config.apiPath}/delivery/validate`;

    const encodedStoreId = encodeURIComponent(storeId);
    const encodedUserZipcode = zipcode && encodeURIComponent(zipcode);
    const encodedUserLatitude =
      coordinates && encodeURIComponent(coordinates['lat']);
    const encodedUserLongitude =
      coordinates && encodeURIComponent(coordinates['long']);

    url = url.concat(
      `?store_id=${encodedStoreId}&user_zipcode=${encodedUserZipcode}&user_latitude=${encodedUserLatitude}&user_longitude=${encodedUserLongitude}`
    );

    return {
      url,
    };
  },
};
